import {
  ValidationMessage,
  Sidebar,
  FormLabel
} from "@/app/shared/components";
import vSelect from 'vue-select';
import service from "./../../staging/stagingDailyReportService.js"

export default {
  props: {    
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ValidationMessage,
    vSelect,
    Sidebar,
    FormLabel
  },
  data() {
    return {
      rows: [],
      projectId: Number(this.$store.state.projectId),
      selectedContractCode: undefined
    };
  },
  created() {
    this.$vs.loading();
    Promise.all([this.$store.dispatch("drilling/fetchAllContracts")])
      .finally(() => {
        this.$vs.loading.close();
      });
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.closeSidebar();
        }
      }
    },
    contractsDropdown() {
      const contracts = this.$store.state.drilling.contracts.filter(c => c.mainProjectId === this.projectId);
      return contracts.map(x => ({code: x.code, display: x.code + " - " + x.company.name, company: x.company }));
    }
  },
  methods: {
    editData() {
      const { rows } = JSON.parse(JSON.stringify(this.data));
      this.rows = rows;
      this.$refs.observer.reset();
    },
    closeSidebar() {
      this.$emit("closeSidebar");
    },
    removeFromBatch(item) {
      if (this.rows.length <= 1) return this.closeSidebar();
      this.rows = this.rows.filter(x => x !== item);
    },
    
    async submitData() {
      this.$refs.observer.validate().then(result => {
        if (!result) return;
        
        const obj = {
          reportIds: this.rows.map(x => x.stagingDailyReportId),
          contractNumber: this.selectedContractCode
        };

        this.$vs.loading();
        
        service.map(obj, this)
          .then(() => {
            this.$emit("onSubmitted");
          })
          .finally(() => {
            this.$vs.loading.close();
          });
      });
    }
  }
};